export const SET_DRAGGING = "SET_DRAGGING";

export function setDragging(dragging) {
  return {
    type: SET_DRAGGING,
    dragging,
  };
}
